import { Component, OnInit } from '@angular/core';
import { Motivo } from 'src/app/interfaces/motivos';
import { MotivosService } from 'src/app/service/motivos.service';


@Component({
  selector: 'app-rechazo',
  templateUrl: './rechazo.component.html',
  styleUrls: ['./rechazo.component.css']
})
export class RechazoComponent implements OnInit {
public motivo:string='';
public motivos:Motivo[]=new Array;
  constructor(private motivoService:MotivosService) {
    this.motivos=motivoService.get()
   }

  ngOnInit(): void {

  }
  enviar(){

  }

}
